import { Link } from 'react-router-dom'
import {KTSVG, WithChildren} from '../../../template/_metronic/helpers'

interface TitleCard {
  title: string
  subtitle: string
  goBack?: string
}
export const TitleCard = ({title, subtitle, goBack, children}: TitleCard & WithChildren) => {
  return (
    <div className='d-flex align-items-center justify-content-between pb-3'>
      <div className='d-flex'>
        {goBack && (
          <Link className='me-5 mt-1' to={goBack}>
            <KTSVG
              path='/media/soyfri-media/angle-small-right.svg'
              className='svg-icon-1x'
            />
          </Link>
        )}
        <div className='d-flex flex-column'>
          <div className='text-primary-dark fs-1 fw-bolder m-0 p-0'>{title}</div>
          <div className='text-gray fs-3 m-0 p-0 mb-4'>{subtitle}</div>
        </div>
      </div>
      {children}
    </div>
  )
}
